<template>
    <div class="py-5 d-flex flex-column align-items-center justify-content-center">
        <h2>Hívjon bizalommal</h2>
        <a href="tel:+36302766007" class="btn btn-primary text-25 grow m-2" @click="googleAnalytics.fireDialEvent()">+36 (30) 276 6007</a>
        <h2>Veszprém és környéke</h2>
		</div>
</template>

<script>
import * as googleAnalytics from "@/utils/google-analytics-utils";

export default {
    name: 'PhoneComponent',
  computed: {
    googleAnalytics() {
      return googleAnalytics
    }
  },
}
</script>

<style lang="scss" scoped>
.text-25 {
    font-size: 2.0rem;
}

.grow { 
  transition: all .2s ease-in-out; 
}

.grow:hover { 
  transform: scale(1.1); 
}
</style>